import deepmerge from "deepmerge";
import {initState} from '../tx-base'

function isSet(obj, key) {
    return obj && obj[key] !== typeof undefined
}

export default function templateResetMutation(moduleDefaultState, template = 'lovemap') {

    return function reset(state, payload) {
        let defaultState = deepmerge(initState(), moduleDefaultState());

        for (const [key, value] of Object.entries(state)) {

            if (payload && state.template === payload.template) {
                if (!isSet(payload, key)) {
                    console.warn(`No Key ${key} in payload backward to default value`, payload, defaultState[key])
                }
                state[key] = payload[key] ?? defaultState[key]

            } else {
                state[key] = defaultState[key]
                if (key === 'template') {
                    state[key] = template
                }
            }

        }
    }
}